<template>
  <div id="stepTwo">
    <h3 v-if="isLoading">Getting your application...</h3>
    <b-form v-if="isLoaded">
      <h2>Student Volunteer Questions</h2>
      <br/>
      <h3>Question 1</h3>
      <b-form-group  label-for="essay1">
        <div class="row">
          <div class="col col-md-8">
            <h6>Tell us about your motivation to be a Student Volunteer. What would make you a great fit for the role?</h6>
            <b-form-textarea id="essay1" @input="wordCount('essay1', 250)" v-model="essay1" :rows="10" :max-rows="100"/>
            <p :class="essay1WordLimitClass">{{ essay1WordCount }}</p>
          </div>
        </div>
      </b-form-group>
      <h3>Question 2</h3>
      <b-form-group label-for="essay2">
        <div class="row">
          <div class="col col-md-8">
            <h6>Tell us about a time when you interacted with individuals from a different background than your own. What did you learn from your experience?</h6>
            <b-form-textarea id="essay2" @input="wordCount('essay2', 250)" v-model="essay2" :rows="10" :max-rows="100"/>
            <p :class="essay2WordLimitClass">{{ essay2WordCount }}</p>
          </div>
        </div>
      </b-form-group>
      <h3>Question 3</h3>
      <b-form-group label-for="essay3">
        <div class="row">
          <div class="col col-md-8">
            <h6>Tell us about a stressful or unexpected situation involving others that YOU specifically took the initiative to resolve. What was your contribution and how did you work towards a resolution? What was the final outcome? What did you learn and how would you apply it to the future?</h6>
            <b-form-textarea id="essay3" @input="wordCount('essay3', 250)" v-model="essay3" :rows="10" :max-rows="100"/>
            <p :class="essay3WordLimitClass">{{ essay3WordCount }}</p>
          </div>
        </div>
      </b-form-group>
      <b-form-group>
        <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-sm float-sm-left" @click="previousStep">Previous Step</button>
        <button type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-sm float-sm-right" @click="nextStep">Save and Continue</button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import router from '@/router'
import moment from 'moment'

const generateVuexSetters = (fields) => {
  let computed = {}
  fields.forEach(field => {
    computed[field] = {
      get () {
        return this.$store.state.application.data[field]
      },
      set (value) {
        this.$store.commit('application/updateField', { name: field, value })
      }
    }
  })
  return computed
}

export default {
  name: 'AppStepTwo',
  data () {
    return {
      essay1WordCount: '250 words remaining',
      essay1WordLimitClass: 'under-limit',
      essay2WordCount: '250 words remaining',
      essay2WordLimitClass: 'under-limit',
      essay3WordCount: '250 words remaining',
      essay3WordLimitClass: 'under-limit',
      disabled: false
    }
  },
  computed: {
    ...generateVuexSetters([
      'essay1',
      'essay2',
      'essay3'
    ]),
    ...mapState('application', ['isLoaded', 'isLoading'])
  },
  methods: {
    wordCount (field, limit) {
      let words = this[field].trim().split(/\s+/)
      let wordCount = (words.length === 1 && words[0] === '') ? 0 : words.length
      let remaining = limit - wordCount
      this[field + 'WordCount'] = (remaining < 0) ? (remaining * -1).toString() + ' words over the limit, you will not be able to submit your application' : remaining.toString() + ' words remaining'
      this[field + 'WordLimitClass'] = (remaining < 0) ? 'over-limit' : 'under-limit'
    },
    nextStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.commit('application/updateStep', 3)
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepThree' })
          this.disabled = true
        }).catch(err => {
          console.log(err.message)
          this.disabled = true
        })
      }
    },
    previousStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.commit('application/updateStep', 1)
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepOne' })
          this.disabled = false
        }).catch(err => {
          console.log(err.message)
          this.disabled = false
        })
      }
    }
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(() => {
        if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
          this.$store.commit('application/disableTeamLeader')
        }
        if (this.$store.state.application.completed) {
          router.push('/dashboard')
        } else if (this.$store.state.application.isNew) {
          this.$store.dispatch('application/save')
        } else if (this.$store.state.application.step !== 2) {
          router.push('/application/' + this.$store.state.application.step.toString())
        }
      })
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader')
    }
    if (this.$store.state.application.completed) {
      router.push('/dashboard')
    }
  },
  mounted: function () {
    this.wordCount('essay1', 250)
    this.wordCount('essay2', 250)
    this.wordCount('essay3', 250)
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/application/StepTwo.vue